import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('RegistrationRequestFilter', RegistrationRequestFilterData);
    RegistrationRequestFilterData.$inject = ['REGISTRATION_REQUEST'];

    function RegistrationRequestFilterData(REGISTRATION_REQUEST) {
        RegistrationRequestFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            prepareBeforeSearch: prepareBeforeSearch,
            setPage: setPage,
            setPageSize: setPageSize,
            setSort: setSort,
            resetSort: resetSort,
        };

        function RegistrationRequestFilter(RegistrationRequestFilterData) {
            if (!RegistrationRequestFilterData) {
                this.buildEmpty();
            } else {
                this.build(RegistrationRequestFilterData);
            }
        }

        return RegistrationRequestFilter;

        function buildEmpty() {
            this.registrationUserName = null;
            this.registrationUserMail = null;
            this.registrationStatus = REGISTRATION_REQUEST.registration_request.status;
            this.companyName = null;
            this.idFiscal = null;
            this.idNational = null;
            this.pageCriteria = {
                pageSize: REGISTRATION_REQUEST.registration_request.defaultPageSize,
                page: REGISTRATION_REQUEST.registration_request.defaultPage,
                sorts: REGISTRATION_REQUEST.registration_request.defaultSort,
            };

        }

        function build(registrationRequestFilterData) {
            this.registrationUserName = registrationRequestFilterData.registrationUserName || null;
            this.registrationUserMail = registrationRequestFilterData.registrationUserMail || null;
            this.registrationStatus = registrationRequestFilterData.registrationStatus || [];
            this.pageCriteria = {
                pageSize:
                registrationRequestFilterData.pageCriteria.pageSize || REGISTRATION_REQUEST.registration_request.pagination.defaultPageSize,
                page: registrationRequestFilterData.pageCriteria.page || REGISTRATION_REQUEST.registration_request.pagination.defaultPage,
                sorts: _setSort(registrationRequestFilterData.pageCriteria.sorts),
            };
        }

        function prepareBeforeSearch() {
            var clone = new RegistrationRequestFilter(this);
            clone.registrationUserName = this.registrationUserName ? this.registrationUserName : null;
            clone.registrationUserMail = this.registrationUserMail ? this.registrationUserMail : null;
            clone.registrationStatus = this.registrationStatus ? _.map(this.registrationStatus,'value') :_.map(REGISTRATION_REQUEST.registration_request.status,'value');
            clone.idFiscal = this.registrationRequestCompany ? this.registrationRequestCompany.idFiscal : null ;
            clone.idNational = this.registrationRequestCompany ? this.registrationRequestCompany.idNational : null ;
            clone.companyName = this.registrationRequestCompany ? this.registrationRequestCompany.companyName : null ;


            return clone;
        }
        function _setSort(sorts) {
            if (!sorts || sorts.length === 0) {
                return REGISTRATION_REQUEST.registration_request.pagination.defaultSort;
            }
            return sorts;
        }

        /**
         * Indiquer la page
         */
        function setPage(page) {
            this.pageCriteria.page = page;
        }

        /**
         * Changement de pagination
         */
        function setPageSize(pageSize) {
            this.pageCriteria.pageSize = pageSize;
        }

        /**
         * Mise à jour du tri (tri sur une seule colonne)
         */
        function setSort(sorts) {
            this.pageCriteria.sorts = sorts;
         }

        /**
         * Lorsqu'on ne souhaite aucun tri pour appliquer le tri par defaut
         */
        function resetSort() {
            this.pageCriteria.sorts = [];
        }

    }
})();
